import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getIdBlog, getListBlog } from "../../redux/actions/actionBlog";
import { AiOutlineUser, AiOutlineSchedule } from "react-icons/ai";
import { useNavigate } from "react-router-dom";
import { Typography } from "@mui/material";

function DetailBlog() {
    const [judul, setJudul] = useState();
    const [imgk, setImgk] = useState();
    const [deskripsi, setDeskripsi] = useState();
    const [datek, setDatek] = useState();
    const [user, setUser] = useState();
    const [timek, setTimek] = useState();

    const {
        getIdBlogResult,
        getListBlogResult,
        getListBlogLoading,
        getListBlogError,
    } = useSelector((state) => state.indexReducerBlog);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getListBlog());
    }, [dispatch]);

    useEffect(() => {
        if (getIdBlogResult) {
            setJudul(getIdBlogResult.judul);
            setImgk(getIdBlogResult.img_url);
            setDeskripsi(getIdBlogResult.deskripsi);
            setDatek(getIdBlogResult.createAt);
            setUser(getIdBlogResult.user);
            setTimek(getIdBlogResult.createTime);
        }
    }, [getIdBlogResult]);

    const navigate = useNavigate();
    const handleDetail = (idk) => {
        navigate(`/Blog/${idk.judul.replace(/ /g, "-")}`);
        dispatch(getIdBlog(idk));
    };

    return (
        <>
            <div className="detail-Blog my-5">
                <div className="row">
                    <div className="content-Blog col-lg-7 col-md-7 offset-lg-1 offset-md-1">
                        <div className="body-title mb-2">
                            <h3>{judul}</h3>
                            <div className="title-date d-flex">
                                <li className="d-flex mr-2">
                                    <AiOutlineSchedule />
                                    <p className="mx-1">
                                        {datek} : {timek}
                                    </p>
                                </li>

                                <li className="d-flex mx-2">
                                    <AiOutlineUser size={14} />
                                    <p className="mx-1">{user}</p>
                                </li>
                            </div>
                        </div>
                        <div className="body-img mb-4">
                            <img src={imgk} className="img-fluid" alt="" />
                        </div>
                        <div className="body-deskripsi mb-4">
                            <p>{deskripsi}</p>
                        </div>
                    </div>
                    <div className="sidebar-Blog col-lg-3 col-md-3 offset-lg-1 offset-md-1 ">
                        <div className="sidebar-Blog-header mb-4">
                            <h5>Relate Topic</h5>
                        </div>
                        <div className="sidebar-blog-content d-block">
                            {getListBlogResult ? (
                                <>
                                    {getListBlogResult
                                        .slice(0, 5)
                                        .map((item, index) => {
                                            return (
                                                <div
                                                    className="list-content border-bottom mb-3"
                                                    key={index}
                                                >
                                                    <div className="row ">
                                                        <div className="d-flex ">
                                                            <div className="col-lg-3 img-div img-fluid">
                                                                <img
                                                                    src={
                                                                        item.img_url
                                                                    }
                                                                    width="50"
                                                                    height="35"
                                                                    alt="sidebar-img"
                                                                />
                                                            </div>
                                                            <div className="col-lg-9  mx-2">
                                                                <Typography
                                                                    className="text-dark text-hidden-content-judul cursor-pointer "
                                                                    onClick={() => {
                                                                        handleDetail(
                                                                            item
                                                                        );
                                                                    }}
                                                                >
                                                                    {item.judul}
                                                                </Typography>

                                                                <p>
                                                                    {
                                                                        item.createAt
                                                                    }
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                </>
                            ) : getListBlogLoading ? (
                                <p>Loading Data</p>
                            ) : (
                                <p>
                                    {getListBlogError
                                        ? getListBlogLoading
                                        : "Data Loading ..."}
                                </p>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default DetailBlog;
